// 把名字清洗成可安全嵌入单个路径段的字符串：
//   去掉路径分隔符 `/ \`（防注入额外目录层级）、折叠空白、去控制字符、去首尾空白。
export const sanitizeName = (name: string): string =>
  name
    .replace(/[/\\]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/\p{Cc}/gu, '')
    .trim()
